module.exports = __webpack_public_path__ + "static/startup-a2641bc612b0cef26cd45cd10d6d6b80.png";